import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from 'lodash';

import Search from '../../../../components/search/Search';
import { Actions } from '../../../../core/state/bookings/actions';
import { getFilters } from '../../../../core/state/bookings/selectors';

const CHANGE_DELAY = 500;

const BookingSearch: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const filters = useSelector(getFilters);

  const { control, setValue } = useForm({
    defaultValues: {
      searchText: ''
    }
  });

  const handleChange = debounce((value: string) => {
    const newFilters = {
      ...filters,
      searchText: value.length > 2 ? value : ''
    };
    dispatch(Actions.changeFilters(newFilters));
  }, CHANGE_DELAY);

  const handleReset = () => {
    const newFilters = {
      ...filters,
      searchText: ''
    };
    dispatch(Actions.changeFilters(newFilters));
  };

  return (
    <Controller
      name="searchText"
      control={control}
      render={({ field: { onChange, value } }) => (
        <Search
          id="searchText"
          name="searchText"
          value={value}
          placeholder={t('common.search')}
          onChange={(e) => {
            handleChange(e.target.value);
            onChange(e);
          }}
          onReset={() => {
            handleReset();
            setValue('searchText', '');
          }}
        />
      )}
    />
  );
};

export default BookingSearch;
